module.exports = "/_next/static/public/images/251eb679489f003d7a2074796ab3f013-764f4eb1d05b3951d76a022dc9e95680.svg";